import { render, staticRenderFns } from "./quickOrderChange.vue?vue&type=template&id=14980434&scoped=true"
import script from "./quickOrderChange.vue?vue&type=script&lang=js"
export * from "./quickOrderChange.vue?vue&type=script&lang=js"
import style0 from "./quickOrderChange.vue?vue&type=style&index=0&id=14980434&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14980434",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14980434')) {
      api.createRecord('14980434', component.options)
    } else {
      api.reload('14980434', component.options)
    }
    module.hot.accept("./quickOrderChange.vue?vue&type=template&id=14980434&scoped=true", function () {
      api.rerender('14980434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/quickOrderChange.vue"
export default component.exports